export const fetchConditionalPropertyOptionsRules = (objectTypeId, httpClient, offset) => {
  return httpClient.get(`conditional-properties/v2/options/${objectTypeId}/unmerged/paged`, {
    query: {
      pageSize: 100,
      offset
    }
  }).then(conditionalPropertyOptionsRules => {
    const {
      results,
      hasMore,
      offset: newOffset
    } = conditionalPropertyOptionsRules;
    if (hasMore) {
      return fetchConditionalPropertyOptionsRules(objectTypeId, httpClient, newOffset).then(moreRules => results.concat(moreRules));
    }
    return results;
  }).catch(err => {
    //Todo: Sentry once Raven is setup in CDP
    console.log(err);
    throw err;
  });
};